import React, { useEffect, useState } from "react";
import Container from "../components/Container";
import { useLocation, useParams } from "react-router-dom";
import Table from "../components/Table";
import FdTable from "../tables/FdTable";
import HeaderBanner from "../components/HeaderBanner";
import RdTable from "../tables/RdTable";
import PlTable from "../tables/PlTable";
import EducationTable from "../tables/EducationTable";
import EarlyLoanCalc from "../calculater/EarlyLoanCalc";
import EarlyLoanTable from "../tables/EarlyLoanTable";
import CreditPayTable from "../tables/CreditPayTable";
import BussinessLoanTable from "../tables/BussinessLoanTable";
import LtvTable from "../tables/LtvTable";
import SavingTable from "../tables/SavingTable";
import ContributionTable from "../tables/ContributionTable";
import useLocale from "../locales";

const HistoryData = ({ activeTab }) => {
  const { textData } = useLocale();
  const location = useLocation();
  const [historyData, setHistoryData] = useState([]);

  useEffect(() => {
    const rowString = location?.state;

    if (rowString) {
      const parsedData = JSON.parse(decodeURIComponent(rowString));
      setHistoryData(parsedData);
      localStorage.setItem("historyData", JSON.stringify(parsedData));
    } else {
      const storedData = localStorage.getItem("historyData");
      if (storedData) {
        setHistoryData(JSON.parse(storedData));
      }
    }
  }, [location?.state]);

  const getCalculationType = () => {
    if (
      Array.isArray(historyData) &&
      historyData?.length > 0 &&
      historyData?.[0]
    ) {
      return historyData?.[0].calculationType;
    }
    return textData.filterDropDown.sipCalc;
  };

  const getTimeUnit = () => {
    if (
      Array?.isArray(historyData) &&
      historyData?.length > 0 &&
      historyData?.[0]
    ) {
      return historyData?.[0].tenureUnit || "Years";
    }
    return "Years";
  };

  const renderTableByType = () => {
    const calculationType = getCalculationType();
    const timeUnit = getTimeUnit();

    switch (calculationType) {
      case "FD":
        return (
          <FdTable
            showTable={true}
            timeUnit={timeUnit}
            historyData={historyData}
          />
        );
      case "RD":
        return (
          <RdTable
            showTable={true}
            timeUnit={timeUnit}
            historyData={historyData}
          />
        );
      case "Personal Loan":
        return <PlTable showTable={true} historyData={historyData} />;
      case "Education Loan":
        return <EducationTable showTable={true} historyData={historyData} />;
      case "Early Loan":
        return <EarlyLoanTable showTable={true} historyData={historyData} />;
      case "Credit":
        return <CreditPayTable showTable={true} historyData={historyData} />;
      case "Bussiness Loan":
        return (
          <BussinessLoanTable showTable={true} historyData={historyData} />
        );
      case "Ltv":
        return <LtvTable showTable={true} historyData={historyData} />;
      case "SavingGoal":
        return <SavingTable showTable={true} historyData={historyData} />;
      case "Contribution":
        return <ContributionTable showTable={true} historyData={historyData} />;
      case "GST":
        return <Table historyData={historyData} activeTab={activeTab} />;
      case "VAT":
        return <Table historyData={historyData} activeTab={activeTab} />;
      case "Salary":
        return <Table historyData={historyData} activeTab={activeTab} />;
      case "Pension":
        return <Table historyData={historyData} activeTab={activeTab} />;
      case "Car":
        return <Table historyData={historyData} activeTab={activeTab} />;
      case "Mortgage":
        return <Table historyData={historyData} activeTab={activeTab} />;
      case "DTI":
        return <Table historyData={historyData} activeTab={activeTab} />;
      case "NetWorth":
        return <Table historyData={historyData} activeTab={activeTab} />;
      default:
        return <Table historyData={historyData} activeTab={activeTab} />;
    }
  };

  const renderTable = renderTableByType();
  const tableBool = renderTable?.props?.showTable;

  return (
    <div>
      <Container>
        <div className="my-[24px] xl:mx-0 sm:mx-[20px] mx-0">
          <HeaderBanner
            name={textData.historyData.titleData}
            backUrl="/history"
          />
        </div>
      </Container>
      <div
        className={` ${tableBool ? "px-0" : "px-0"}`}
      >
        {renderTable}
      </div>
    </div>
  );
};

export default HistoryData;
